import React, { Component } from 'react';
import './CheckMark.scss';
import FormError from '../FormError/FormError';

export default class CheckMark extends Component {
  render() {
    return (
      <div className="form_checkmarks" style={this.props.style} >
        <div>
          <input
            type={this.props.type}
            id={this.props.id}
            name={this.props.name}
            onChange={(event)=>{ this.props.onChange(event.target.checked) }}
            required={this.props.required}
            disabled={this.props.disabled}
            defaultChecked={ this.props.checked }
          />

          <label htmlFor={this.props.id}>
            {this.props.label}
          </label>
        </div>

        {
          this.props.error ? (
            <FormError inner={this.props.error} />
          ) : null
        }
      </div>
    )
  }
}
